export default function analyticsConfig(AnalyticsProvider, appConfig) {
	'ngInject';
	AnalyticsProvider.setAccount({
		tracker: appConfig.constants.googleAnalyticsTrackingId,
		set: {
			anonymizeIp: true
		}
	});
}
